import React, { useEffect } from "react";
import "./Paginacion.css";

/**
 * Componente de paginación
 * @param {*} props - Props del componente
 * @returns {JSX.Element}
 */
const Paginacion = (props) => {
    const {
        cantidadResultados = 0,
        paginaSeleccionada = 1,
        setPaginaSeleccionada = () => {},
    } = props;

    const cantidadPaginas = Math.ceil(cantidadResultados / 10);
    if (cantidadPaginas <= 1)
        return <div className="new-paginacion__no-content mb-3"></div>;

    const paginasAMostrar = 5;

    let startPage = Math.max(
        1,
        paginaSeleccionada - Math.floor(paginasAMostrar / 2),
    );

    let endPage = startPage + paginasAMostrar - 1;

    // Si nos pasamos del total, ajustamos hacia atrás
    if (endPage > cantidadPaginas) {
        endPage = cantidadPaginas;
        startPage = Math.max(1, endPage - paginasAMostrar + 1);
    }

    return (
        <div className="new-paginacion__container">
            <div className="new-paginacion__buttons">
                {/* Ir a la primera página */}
                {paginaSeleccionada > 1 && (
                    <button
                        className="new-paginacion__nav-button"
                        onClick={() => setPaginaSeleccionada(1)}
                    >
                        {"<<"}
                    </button>
                )}

                {/* Ir a la página anterior */}
                <button
                    className="new-paginacion__nav-button"
                    disabled={paginaSeleccionada === 1}
                    onClick={() =>
                        setPaginaSeleccionada(paginaSeleccionada - 1)
                    }
                >
                    {"<"}
                </button>

                {/* mostrar 5 botones de páginas */}
                {Array.from({ length: endPage - startPage + 1 }, (_, index) => {
                    const pagina = startPage + index;

                    return (
                        <button
                            key={pagina}
                            className={`new-paginacion__page-number ${
                                pagina === paginaSeleccionada ? "active" : ""
                            }`}
                            onClick={() => setPaginaSeleccionada(pagina)}
                        >
                            {pagina}
                        </button>
                    );
                })}

                {/* Ir a la página siguiente */}
                <button
                    className="new-paginacion__nav-button"
                    disabled={paginaSeleccionada === cantidadPaginas}
                    onClick={() =>
                        setPaginaSeleccionada(paginaSeleccionada + 1)
                    }
                >
                    {">"}
                </button>

                {/* Ir a la última página */}
                {paginaSeleccionada < cantidadPaginas && (
                    <button
                        className="new-paginacion__nav-button"
                        onClick={() => setPaginaSeleccionada(cantidadPaginas)}
                    >
                        {">>"}
                    </button>
                )}
            </div>
        </div>
    );
};

export default Paginacion;
